<script>
import LocalStorageAdapter from '@/utils/LocalStorageAdapter'

export default {
  render() {
    return this.$slots.default({
      getKey: LocalStorageAdapter.get,
      setKey: LocalStorageAdapter.set,
      remove: LocalStorageAdapter.remove,
    })
  },
}
</script>
